import { isEditorPluginAIConfigItemWithOptions } from './config-items/config-items';
import { brainstormWithOptions } from './config-items/prompts/brainstorm/brainstorm';
import { changeToneToCasualWithOptions, changeToneToEducationalWithOptions, changeToneToEmpatheticWithOptions, changeToneToNeutralWithOptions, changeToneToProfessionalWithOptions } from './config-items/prompts/change-tone/change-tone';
import { fixSpellingAndGrammarWithOptions, improveWritingWithOptions } from './config-items/prompts/enhance/enhance';
import { freeGenerate } from './config-items/prompts/free-generate/free-generate';
import { makeShorterWithOptions } from './config-items/prompts/make-shorter/make-shorter';
import { createPrDescriptionWithOptions } from './config-items/prompts/pr-description/pr-description';
import { summarizeWritingWithOptions } from './config-items/prompts/summarize-writing/summarize-writing';
import { _getFetchCustomHeaders } from './utils';
export var createBBEditorPluginAIOptions = function createBBEditorPluginAIOptions(options) {
  var _options$disableInter;
  // Now deprecated - migrate to handleFeedbackSubmission
  var onExperienceEvent = (options === null || options === void 0 ? void 0 : options.onExperienceEvent) || {
    THUMBS_UP: function THUMBS_UP() {},
    THUMBS_DOWN: function THUMBS_DOWN() {},
    REVIEW_STATE_ENTERED: function REVIEW_STATE_ENTERED() {},
    EXPERIENCE_COMPLETE: function EXPERIENCE_COMPLETE() {}
  };
  return {
    aiGlobalOptIn: options.aiGlobalOptIn,
    baseGenerate: freeGenerate,
    configItemWithOptions: [!!options.summarisePrDescriptionUrl && createPrDescriptionWithOptions({
      generativeAIApiUrl: options.summarisePrDescriptionUrl
    }), summarizeWritingWithOptions, improveWritingWithOptions, fixSpellingAndGrammarWithOptions, brainstormWithOptions, makeShorterWithOptions, changeToneToProfessionalWithOptions, changeToneToEmpatheticWithOptions, changeToneToCasualWithOptions, changeToneToNeutralWithOptions, changeToneToEducationalWithOptions].filter(isEditorPluginAIConfigItemWithOptions),
    disableAISelectionToolbar: true,
    generativeAIApiUrl: options.generativeAIApiUrl,
    product: options.product ? options.product : 'BITBUCKET',
    objectId: options.objectId,
    getFetchCustomHeaders: (options === null || options === void 0 ? void 0 : options.getFetchCustomHeaders) || _getFetchCustomHeaders,
    onExperienceEvent: onExperienceEvent,
    handleFeedbackSubmission: options === null || options === void 0 ? void 0 : options.handleFeedbackSubmission,
    AIButtonWrapper: options.AIButtonWrapper,
    PromptEditor: options.PromptEditor,
    disableInterrogation: (_options$disableInter = options.disableInterrogation) !== null && _options$disableInter !== void 0 ? _options$disableInter : false
  };
};